
import React from 'react';
import { IProps, classPrefix } from './types';
import { useEffect } from 'react';
import Draggable from 'react-draggable';
import { Close } from "@material-ui/icons";
import { Paper, Button, Dialog, DialogActions, DialogContent, DialogTitle, makeStyles, Typography, PaperProps, IconButton } from '@material-ui/core';


const NS = 'AlertDialog';

/** Styles for alert dialog */
const useStyles = makeStyles({
  title: {
    color: 'white',
    backgroundColor: 'black',
    '& h2': {
      fontSize: '2rem'
    }
  }
});

const draggableDialogTitleId = "draggable-dialog-title";

/**
 * Displays a message within a alert box
 */
export default function AlertDialog(props: IProps) {

  const { children, dialogHeaderText, onAlertDialogClose, shouldShowCloseButton, dialogWidth = "md", closeButtonText = "OK", showAlertDialog = false, shouldShowActionButtons = true } = props;

  const classes = useStyles();
  const [open, setOpen] = React.useState(false);

  useEffect(() => { toggleAlertDialog(showAlertDialog) }, [showAlertDialog]);

  /** Open/close the alert dialog */
  const toggleAlertDialog = (shouldOpenDialog: boolean) => setOpen(shouldOpenDialog);

  /** Perform closing task */
  const closeAlertDialog = () => {
    toggleAlertDialog(false);
    onAlertDialogClose();
  }

  return (
    <Dialog
      open={open}
      scroll="paper"
      fullWidth={true}
      maxWidth={dialogWidth}
      PaperComponent={DraggableComponent}
      aria-labelledby="alert-dialog-title"
      aria-describedby="alert-dialog-description">
      <DialogTitle id={draggableDialogTitleId} className={classes.title}>
        {dialogHeaderText}
        {
          shouldShowCloseButton &&
          <IconButton aria-label="close" onClick={closeAlertDialog}><Close /></IconButton>
        }
      </DialogTitle>
      <DialogContent>
        <Typography component={'div'}>{children}</Typography>
      </DialogContent>
      {
        shouldShowActionButtons &&
        <DialogActions>
          <Button onClick={closeAlertDialog} color="primary" autoFocus>{closeButtonText}</Button>
        </DialogActions>
      }
    </Dialog>
  )
}

/** This component uses react-draggable which lets us specify the draggable item by passing the selector item we want to make draggable to the handle prop. */
function DraggableComponent(props: JSX.IntrinsicAttributes & PaperProps) {
  return (
    <Draggable handle={`#${draggableDialogTitleId}`} cancel={'[class*="MuiDialogContent-root"]'}>
      <Paper {...props} />
    </Draggable>
  );
}
